import { z } from "zod";

/** `POST /v1/auth/login` body. */
export const loginSchema = z.object({
  email: z.string().trim().min(1, "email is required").email("must be a valid email"),
  password: z.string().min(1, "password is required"),
});
export type LoginInput = z.infer<typeof loginSchema>;
